import { AssetNewAttributes } from '@/types'
import { CreateAssetMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateAssetMutation, AssetNewAttributes, never, never>({
    defaultValues: {
      assetTypeId: '',
      quantity: 1
    },
    mutation: CreateMutation,
    resultKey: 'createAsset',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2">
          { formBuilder.buildField({ name: 'Asset type', field: 'assetTypeId', type: 'asset-type' }) }
        </div>
        { formBuilder.buildField({ name: 'Quantity', field: 'quantity', type: 'integer' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
